import { render } from "./SeleccionEmisor.vue?vue&type=template&id=97fda4b0&scoped=true"
import script from "./SeleccionEmisor.vue?vue&type=script&lang=js"
export * from "./SeleccionEmisor.vue?vue&type=script&lang=js"

import "./SeleccionEmisor.vue?vue&type=style&index=0&id=97fda4b0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97fda4b0"]])

export default __exports__